(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hrc-pf-assets"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   HRC · PRETEMPORADA EFICAZ — comportamiento de la landing
   - Sin dependencias externas. Idempotente. Compatible con el Theme Editor.
   - Features: scroll-reveal, slider + lightbox, sticky CTA, exit-intent,
     formularios Klaviyo (Client API), tracking de eventos, add-to-cart AJAX.
   ========================================================================== */
(function () {
  'use strict';

  // Se carga una sola vez vía el bloque javascript de la seccion
  // "HRC PF - Nucleo CSS/JS"; el guard es defensivo por si se re-inyecta.
  if (window.HRCPF && window.HRCPF.__loaded) return;

  var PF = (window.HRCPF = window.HRCPF || {});
  PF.__loaded = true;
  var STORE = {
    lead: 'hrc_pf_lead_done',
    purchased: 'hrc_pf_purchased',
    exitShown: 'hrc_pf_exit_shown',
    stickyClosed: 'hrc_pf_sticky_closed'
  };

  /* ----------------------------- utilidades ----------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return !window.matchMedia || window.matchMedia('(max-width: 749px)').matches; };

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  }

  /* ------------------------------ tracking ----------------------------- */
  PF.track = function (name, params) {
    params = params || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params); } catch (e) {}
    try { if (typeof window.ttq === 'object' && window.ttq.track) window.ttq.track(name, params); } catch (e) {}
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', name, params]);
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('hrc-pf:' + name, { detail: params })); } catch (e) {}
  };

  /* --------------------------- scroll reveal --------------------------- */
  function initReveal(root) {
    var items = $all('[data-pf-reveal], [data-pf-stagger]', root).filter(function (el) { return !el.__pfRevealed; });
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); el.__pfRevealed = true; });
      return;
    }
    // Revela de inmediato lo que ya está en (o cerca de) el viewport,
    // sin esperar al primer tick del observer (evita el flash del hero).
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items = items.filter(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.9) {
        el.classList.add('is-in');
        el.__pfRevealed = true;
        return false;
      }
      return true;
    });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          entry.target.__pfRevealed = true;
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------ slider ------------------------------ */
  function initSliders(root) {
    $all('[data-pf-slider]', root).forEach(function (slider) {
      if (slider.__pfInit) return;
      slider.__pfInit = true;
      var track = $('[data-pf-slider-track]', slider);
      var prev = $('[data-pf-slider-prev]', slider);
      var next = $('[data-pf-slider-next]', slider);
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
        return first.getBoundingClientRect().width + gap;
      }
      function updateButtons() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateButtons); }, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();

      // Lightbox
      var dialog = $('[data-pf-lightbox]', slider);
      if (dialog && typeof dialog.showModal === 'function') {
        var lbImg = $('[data-pf-lightbox-img]', dialog);
        var lbCap = $('[data-pf-lightbox-cap]', dialog);
        var closeBtn = $('[data-pf-lightbox-close]', dialog);
        $all('[data-pf-slide]', track).forEach(function (slide) {
          slide.addEventListener('click', function () {
            var full = slide.getAttribute('data-pf-full');
            var cap = slide.getAttribute('data-pf-cap') || '';
            if (!full) return;
            if (lbImg) { lbImg.src = full; lbImg.alt = cap; }
            if (lbCap) lbCap.textContent = cap;
            dialog.showModal();
            PF.track('hrc_preview_open', { caption: cap });
          });
        });
        if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (e) {
          var box = $('[data-pf-lightbox-inner]', dialog);
          if (box && !box.contains(e.target)) dialog.close();
        });
      }
    });
  }

  /* --------------------------- add to cart ---------------------------- */
  function initBuyForms(root) {
    $all('[data-pf-buyform] form', root).forEach(function (form) {
      if (form.__pfInit) return;
      form.__pfInit = true;
      var wrap = form.closest('[data-pf-buyform]');
      var loc = wrap.getAttribute('data-pf-loc') || 'buybox';
      var addUrl = wrap.getAttribute('data-pf-add-url') || '/cart/add';
      var after = wrap.getAttribute('data-pf-after') || 'checkout';
      var cartUrl = wrap.getAttribute('data-pf-cart-url') || '/cart';
      var checkoutUrl = wrap.getAttribute('data-pf-checkout-url') || '/checkout';

      form.addEventListener('submit', function (e) {
        if (form.__pfBusy) { e.preventDefault(); return; }
        PF.track('hrc_product_cta_click', { location: loc });
        if (!window.fetch) return; // sin fetch: envío nativo → Shopify redirige a /cart
        e.preventDefault();
        form.__pfBusy = true;
        var btn = form.querySelector('[name="add"]');
        var span = btn && btn.querySelector('span');
        var prevLabel = span ? span.textContent : '';
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; if (span) span.textContent = 'Añadiendo…'; }

        var reset = function () {
          form.__pfBusy = false;
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; if (span) span.textContent = prevLabel; }
        };
        var ac = ('AbortController' in window) ? new AbortController() : null;
        var timer = window.setTimeout(function () { if (ac) ac.abort(); }, 12000);

        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form),
          signal: ac ? ac.signal : undefined
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            window.clearTimeout(timer);
            if (!res.ok) throw new Error((res.body && res.body.description) || 'add-to-cart');
            PF.track('hrc_add_to_cart', { location: loc });
            window.location.href = after === 'cart' ? cartUrl : checkoutUrl;
          })
          .catch(function () {
            window.clearTimeout(timer);
            reset();
            try { form.submit(); } catch (err) {} // último recurso: envío nativo
          });
      });
    });
  }

  /* ---------------------------- Klaviyo ------------------------------- */
  // Client API pública: sólo viaja la public key (company_id), nada sensible.
  function klaviyoSubscribe(opts) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: opts.source || 'landing-pretemporada',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: opts.email,
                properties: opts.properties || {}
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: opts.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(opts.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body),
      signal: opts.signal
    });
  }

  function bindLeadForm(formEl) {
    if (!formEl || formEl.__pfInit) return;
    formEl.__pfInit = true;
    var scope = formEl.closest('[data-pf-lead], [data-pf-exit], [data-pf-exit-banner]') || formEl.parentNode;
    var companyId = formEl.getAttribute('data-pf-company') || '';
    var listId = formEl.getAttribute('data-pf-list') || '';
    var source = formEl.getAttribute('data-pf-source') || 'landing-pretemporada';
    var resource = formEl.getAttribute('data-pf-resource') || 'checklist-pretemporada';
    var errEl = $('[data-pf-lead-error]', scope) || $('[data-pf-exit-error]', scope);
    var okEl = $('[data-pf-lead-success]', scope) || $('[data-pf-exit-success]', scope);
    var input = $('input[type="email"]', formEl);
    var submitBtn = formEl.querySelector('button[type="submit"], .pf-btn');
    var btnLabel = submitBtn && (submitBtn.querySelector('[data-pf-btn-label]') || submitBtn.querySelector('span'));
    var labelText = btnLabel ? btnLabel.textContent : '';

    function showError(msg) {
      if (input) input.setAttribute('aria-invalid', 'true');
      if (errEl) { errEl.textContent = msg; errEl.classList.add('is-visible'); }
    }
    function clearError() {
      if (input) input.removeAttribute('aria-invalid');
      if (errEl) { errEl.classList.remove('is-visible'); errEl.textContent = ''; }
    }
    function setBusy(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      if (on) { submitBtn.setAttribute('aria-busy', 'true'); if (btnLabel) btnLabel.textContent = 'Enviando…'; }
      else { submitBtn.removeAttribute('aria-busy'); if (btnLabel) btnLabel.textContent = labelText; }
    }

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (formEl.__pfBusy) return;
      clearError();
      var email = input ? input.value.trim() : '';
      if (!validEmail(email)) {
        showError('Introduce un email válido.');
        if (input) input.focus();
        return;
      }

      if (!companyId || !listId) {
        showError('El formulario aún no está conectado. Configura Klaviyo en el editor del tema.');
        return;
      }

      formEl.__pfBusy = true;
      setBusy(true);

      var done = false;
      var ac = ('AbortController' in window) ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (ac) ac.abort(); }, 12000);

      var finish = function (success) {
        if (done) return;
        done = true;
        window.clearTimeout(timer);
        formEl.__pfBusy = false;
        setBusy(false);
        if (success) {
          lsSet(STORE.lead, '1');
          PF.track('hrc_lead_submit', { resource: resource, source: source });
          var container = formEl.closest('[data-pf-lead]');
          if (container) container.setAttribute('data-state', 'done');
          formEl.hidden = true;
          formEl.style.display = 'none';
          if (okEl) {
            okEl.classList.add('is-visible');
            try { okEl.setAttribute('tabindex', '-1'); okEl.focus({ preventScroll: false }); } catch (err) {}
          }
          hideSecondaryCapture(formEl);
        } else {
          showError('No hemos podido registrar tu email. Inténtalo de nuevo en unos segundos.');
          if (input) input.focus();
        }
      };

      klaviyoSubscribe({
        companyId: companyId,
        listId: listId,
        email: email,
        source: source,
        properties: { lead_magnet: resource, source_page: location.pathname },
        signal: ac ? ac.signal : undefined
      })
        .then(function (r) { finish(r.status >= 200 && r.status < 300); })
        .catch(function () { finish(false); });
    });

    if (input) {
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) clearError(); });
    }
  }

  function initLeadForms(root) {
    $all('[data-pf-lead-form]', root).forEach(bindLeadForm);
  }

  /* ------------------------- sticky mobile CTA ------------------------ */
  var stickyEl, buyboxEl, heroEl, stickyIO;
  function initSticky(root) {
    stickyEl = $('[data-pf-sticky]') || stickyEl;
    if (!stickyEl || stickyEl.__pfInit) return;
    stickyEl.__pfInit = true;
    heroEl = $('[data-pf-hero]');
    buyboxEl = $('[data-pf-buybox]');
    var closeBtn = $('[data-pf-sticky-close]', stickyEl);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      stickyEl.classList.remove('is-visible');
      ssSet(STORE.stickyClosed, '1');
    });
    var cta = stickyEl.querySelector('[data-pf-cta]');
    if (cta) cta.addEventListener('click', function () { PF.track('hrc_product_cta_click', { location: 'sticky' }); });

    // Ocultar la sticky cuando cualquier CTA de compra a página completa está
    // en pantalla (Buy Box o cierre CTA final) para no duplicar la llamada.
    var offerEls = $all('[data-pf-buybox], [data-pf-sticky-hide]');
    var offerVisible = false;
    if ('IntersectionObserver' in window && offerEls.length) {
      var seen = {};
      stickyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.__pfId || (en.target.__pfId = Math.random())] = en.isIntersecting; });
        offerVisible = Object.keys(seen).some(function (k) { return seen[k]; });
        evaluate();
      }, { threshold: 0.12 });
      offerEls.forEach(function (el) { stickyIO.observe(el); });
    }
    function evaluate() {
      if (ssGet(STORE.stickyClosed) === '1' || lsGet(STORE.purchased) === '1' || document.body.classList.contains('pf-exit-banner-open')) {
        stickyEl.classList.remove('is-visible');
        return;
      }
      var pastHero = true;
      if (heroEl) pastHero = heroEl.getBoundingClientRect().bottom < 0;
      stickyEl.classList.toggle('is-visible', pastHero && !offerVisible);
    }
    PF.__stickyEvaluate = evaluate;
    window.addEventListener('scroll', function () { window.requestAnimationFrame(evaluate); }, { passive: true });
    evaluate();
  }

  /* --------------------------- exit intent --------------------------- */
  function suppressed() {
    return lsGet(STORE.lead) === '1' || lsGet(STORE.purchased) === '1' || ssGet(STORE.exitShown) === '1';
  }
  // Cierra las superficies de captación secundaria (exit dialog / banner móvil),
  // EXCEPTO aquella desde la que se acaba de enviar (para que muestre su éxito).
  function hideSecondaryCapture(exceptEl) {
    var d = $('[data-pf-exit]');
    if (d && d.open && !(exceptEl && d.contains(exceptEl))) d.close();
    var b = $('[data-pf-exit-banner]');
    if (b && !(exceptEl && b.contains(exceptEl))) {
      b.classList.remove('is-visible');
      document.body.classList.remove('pf-exit-banner-open');
    }
    if (PF.__stickyEvaluate) PF.__stickyEvaluate();
  }
  function initExitIntent(root) {
    var dialog = $('[data-pf-exit]');
    var banner = $('[data-pf-exit-banner]');
    if (!dialog && !banner) return;
    if (dialog && !dialog.__pfInit) {
      dialog.__pfInit = true;
      var closeBtn = $('[data-pf-exit-close]', dialog);
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) {
        var inner = $('[data-pf-exit-inner]', dialog);
        if (inner && !inner.contains(e.target)) dialog.close();
      });
      bindLeadForm($('[data-pf-lead-form]', dialog));
    }
    if (banner && !banner.__pfInit) {
      banner.__pfInit = true;
      var bClose = $('[data-pf-exit-banner-close]', banner);
      if (bClose) bClose.addEventListener('click', function () {
        banner.classList.remove('is-visible');
        document.body.classList.remove('pf-exit-banner-open');
        if (PF.__stickyEvaluate) PF.__stickyEvaluate();
        ssSet(STORE.exitShown, '1');
      });
      bindLeadForm($('[data-pf-lead-form]', banner));
    }

    if (PF.__exitBound) return;
    PF.__exitBound = true;

    if (isMobile()) {
      if (!banner) return;
      var threshold = parseInt(banner.getAttribute('data-pf-scroll') || '55', 10);
      var onScroll = function () {
        if (suppressed()) { window.removeEventListener('scroll', onScroll); return; }
        var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
        if (pct >= threshold) {
          banner.classList.add('is-visible');
          document.body.classList.add('pf-exit-banner-open'); // la sticky se aparta
          if (PF.__stickyEvaluate) PF.__stickyEvaluate();
          ssSet(STORE.exitShown, '1');
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var armed = false;
      window.setTimeout(function () { armed = true; }, 4000);
      document.addEventListener('mouseout', function (e) {
        if (!armed || suppressed()) return;
        // No interrumpir si el usuario ya está mirando la oferta.
        var bb = $('[data-pf-buybox]');
        if (bb) {
          var r = bb.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) return;
        }
        if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
          dialog.showModal();
          ssSet(STORE.exitShown, '1');
          PF.track('hrc_exit_intent_view', {});
        }
      });
    }
  }

  /* ---------------- supresión del popup global de Klaviyo -------------- */
  // Esta landing tiene su propio lead magnet. Suprimimos SOLO en esta página
  // el/los popup(s) generales de Klaviyo (no toca la campaña para el resto de
  // la tienda). Lo ideal es excluir esta URL en el targeting del formulario en
  // Klaviyo; esto es una red de seguridad, desactivable desde el editor.
  function initKlaviyoSuppression() {
    if (PF.__klBound) return;
    var cfg = document.querySelector('[data-hrc-pf-config]');
    if (!cfg || cfg.getAttribute('data-suppress-klaviyo') !== 'true') return;
    PF.__klBound = true;

    // Formularios propios: los identificamos para NO tocarlos nunca.
    function isOurForm(node) {
      return !!(node && node.closest && node.closest('[data-pf-lead], [data-pf-exit], [data-pf-exit-banner]'));
    }
    function hideNode(node) {
      if (!node || isOurForm(node)) return;
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('aria-hidden', 'true');
    }
    // 1) Evento nativo de Klaviyo cuando un formulario va a abrirse.
    document.addEventListener('klaviyoForms', function (e) {
      try {
        if (!e.detail || e.detail.type !== 'open') return;
        var host = document.querySelector('.klaviyo-form-' + e.detail.formId) ||
                   (e.detail.$elem && e.detail.$elem[0]);
        hideNode(host);
      } catch (err) {}
    });
    // 2) Fallback: observamos contenedores de popup Klaviyo que aparezcan.
    try {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes || [], function (n) {
            if (n.nodeType !== 1) return;
            var el = n.matches && n.matches('[class*="klaviyo-form-"]') ? n
                   : (n.querySelector && n.querySelector('[class*="klaviyo-form-"]'));
            if (!el || isOurForm(el)) return;
            // sólo popups/flyouts (position fixed), nunca formularios embebidos inline
            var pos = getComputedStyle(el).position;
            var host = (pos === 'fixed' || pos === 'sticky') ? el : el.closest('div[style*="position: fixed"], div[style*="position:fixed"]');
            if (host && !isOurForm(host)) hideNode(host);
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { mo.disconnect(); }, 15000);
    } catch (err) {}
  }

  /* --------------------- parállax leve del mockup -------------------- */
  function initParallax(root) {
    if (reduceMotion) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    var el = $('[data-pf-parallax]', root);
    if (!el || el.__pfInit) return;
    el.__pfInit = true;
    var ticking = false;
    function update() {
      ticking = false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      // progreso -1..1 según la posición del centro del elemento en el viewport
      var p = ((r.top + r.height / 2) / vh - 0.5) * 2;
      p = Math.max(-1, Math.min(1, p));
      el.style.transform = 'translate3d(0,' + (p * -14).toFixed(1) + 'px,0)';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ------------------------------ init ------------------------------- */
  function init(root) {
    root = root || document;
    try { initKlaviyoSuppression(); } catch (e) {}
    try { initReveal(root); } catch (e) {}
    try { initSliders(root); } catch (e) {}
    try { initBuyForms(root); } catch (e) {}
    try { initLeadForms(root); } catch (e) {}
    try { initSticky(root); } catch (e) {}
    try { initExitIntent(root); } catch (e) {}
    try { initParallax(root); } catch (e) {}
  }
  PF.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme Editor: reinicializa la sección recargada
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
